import React, { memo } from 'react';
import { FadeIn } from '../ui/FadeIn';
const visaSteps = [{
  letter: 'V',
  title: 'Visualización'
}, {
  letter: 'I',
  title: 'Intensidad'
}, {
  letter: 'S',
  title: 'Selección'
}, {
  letter: 'A',
  title: 'Asociación'
}];
export function MethodVISA() {
  return <section className="bg-navy-900 py-24 md:py-32 px-6 relative overflow-hidden" data-id="element-121">
      {/* Subtle decorative background lines */}
      <div className="absolute inset-0 opacity-10 pointer-events-none" data-id="element-122">
        <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" data-id="element-123">
          <defs data-id="element-124">
            <pattern id="grid" width="40" height="40" patternUnits="userSpaceOnUse" data-id="element-125">
              <path d="M 40 0 L 0 0 0 40" fill="none" stroke="#C9A24A" strokeWidth="1" data-id="element-126" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#grid)" data-id="element-127" />
        </svg>
      </div>

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-128">
        <FadeIn data-id="element-129">
          <div className="text-center mb-16" data-id="element-130">
            <h2 className="font-serif text-3xl md:text-5xl text-cream-50 font-bold mb-6" data-id="element-131">
              El Mecanismo Único
            </h2>
            <p className="text-xl md:text-2xl text-gold-400 font-medium max-w-3xl mx-auto" data-id="element-132">
              El Método V.I.S.A. es un protocolo de neuro-activación lingüística
              creado específicamente para la mujer latina.
            </p>
          </div>
        </FadeIn>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-8 mb-16" data-id="element-133">
          {visaSteps.map((step, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-134">
              <div className="bg-navy-800 border border-gold-500/30 rounded-2xl p-6 text-center h-full flex flex-col items-center justify-center" data-id="element-135">
                <span className="font-serif text-5xl md:text-6xl text-gold-400 font-bold mb-2" data-id="element-136">
                  {step.letter}
                </span>
                <span className="text-lg md:text-xl text-cream-100 font-medium" data-id="element-137">
                  {step.title}
                </span>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.4} data-id="element-138">
          <div className="bg-navy-800/50 backdrop-blur-sm rounded-3xl p-8 md:p-12 border border-navy-800" data-id="element-139">
            <p className="text-xl md:text-2xl text-cream-50 leading-relaxed text-center" data-id="element-140">
              A diferencia de otros métodos, este sistema utiliza sus propios
              recuerdos, su lengua materna y su contexto cultural para crear
              "anclas" de memoria indestructibles. Es como darle un gimnasio
              privado a sus neuronas, devolviéndoles la plasticidad que tenían
              hace 20 años.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}